import $ from 'jquery';
import shared from '../scripts/shared';

$.addInit(function(context){
	var base = '.i-scroll';

	$(base, context).each(function(){
		var component = $(this);
		var offset = shared.headerHeight + shared.scrollOffset;
		var target;

		component.on('click', function(e){
			if (component.data('scroll-to')) {
				target = $(this).data('scroll-to');
			} else {
				e.preventDefault();
				target = $(this).attr('href');

				$(target).trigger('show');
			}

			setTimeout(function() {
				if ($(target).length > 0) {
					$('html,body').animate({ scrollTop: $(target).offset().top - offset}, 1000);
				}
			});
		});
	});
});
